export const OPKey = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  DESIGNATION: 'designation',
  MOBILE: 'mobile',
  PERSONAL_EMAIL: 'email',
  COMPANY_NAME: 'companyName',
  COMPANY_ADDRESS: 'registeredHeadOfficeAddress',
  COMPANY_COUNTRY: 'registeredHeadOfficeCountry',
  YEAR_OF_INCORP: 'incorporationYear',
  TOTAL_FLOOR_SPACE: 'totalFloorSpace',
  TOTAL_EMP: 'totalNumberOfEmployees',
  FLEET_NUM: 'totalNoOfVehicle',
  BUSINESS_EMAIL: 'businessEmail',
  TELEPHONE: 'telephone',
  TAX: 'taxIdentityNumber',
  NINO: 'nino',
  CRN: 'crn',
  VAT: 'vat',
  IDENTITY: 'identityProof',
  COMPANY: 'corporateIdentityNumber',
  WEBSITE: 'website',
  TOTAL_REVENUE: 'totalRevenue',
  AUTH_CAP: 'authorizedCapital',
  PAID_CAP: 'paidUpCapital',
  CATEGORY: 'category',
  SUB_CATEGORY: 'subCategory',
  FINANCIAL_YEAR_TYPE: 'fiscalYear',
  TYPE_OF_BUSINESS: 'typeOfBusiness',
  BASE_YEAR: 'baseLineYear',
  TARGET_YEAR: 'targetYear',
  BUSINESS_YEAR: 'year'
} as const;
export const OPLabel = {
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  DESIGNATION: 'Designation in the company',
  MOBILE: 'Mobile Number',
  PERSONAL_EMAIL: 'Personal Email ID',
  COMPANY_NAME: 'Company Name',
  COMPANY_ADDRESS: 'Registered Office Address',
  COMPANY_COUNTRY: 'Registered Office Country',
  REGISTERED_BUSINESS_COUNTRY: 'Registered Business Country',
  YEAR_OF_INCORP: 'Year of Incorporation',
  TOTAL_FLOOR_SPACE: 'Total Floor Space',
  TOTAL_EMP: 'Total Number of Employees',
  FLEET_NUM: 'Total Number of Vehicles',
  BUSINESS_EMAIL: 'Business Email ID',
  TELEPHONE: 'Contact Number',
  GST: 'GST Number',
  PAN: 'PAN',
  CIN: 'CIN',
  SSN: 'SSN',
  EIN: 'EIN',
  IDENTIY_NUMBER: 'Individual Number',
  FINANCIAL_YEAR_TYPE: 'Financial Year Preference',
  CORP_NUM: 'Corporate Number',
  WEBSITE: 'Website',
  TOTAL_REVENUE: 'Total Revenue',
  AUTH_CAP: 'Authorized Capital',
  PAID_CAP: 'Paid-Up Capital',
  CATEGORY: 'Category',
  SUB_CATEGORY: 'Sub-Category',
  INDUSTRY_CATEGORY: 'Your Industry Category',
  INDUSTRY_SUB_CATEGORY: 'Your Industry Sub-Category',
  TYPE_OF_BUSINESS: 'Business Type',
  BASE_YEAR: 'Base Line Year',
  TARGET_YEAR: 'Target Year',
  BUSINESS_YEAR: 'Year',
  NINO: 'National Insurance Number',
  CRN: 'Company Registration Number',
  VAT: 'Value Added Tax'
};

export const OPplaceholder = {
  PAN: 'XXXXX0000X',
  GST: '00XXXXX0000X0X0/X',
  CIN: 'X00000XX0000XXX000000',
  SSN: '000000000',
  EIN: '000000000',
  IDENTIY_NUMBER: '000000000000',
  CORP_NUM: '0000000000000',
  NINO: 'XX000000X',
  CRN: '00000000 OR XX000000',
  VAT: '000000000 OR 000000000000'
};
